/* ============================================
   VIZELIA — JavaScript Custom
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // --- 1. CURSEUR CUSTOM ---
  const cursor = document.createElement('div');
  cursor.classList.add('cursor');
  document.body.appendChild(cursor);

  document.addEventListener('mousemove', (e) => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });

  // Agrandit le curseur au hover sur liens/boutons
  const hoverTargets = document.querySelectorAll('a, button, .btn, .card-wrapper, summary');
  hoverTargets.forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
  });


  // --- 2. NAVBAR : apparaît au scroll ---
  const header = document.querySelector('header, .header-wrapper, .site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) {
        header.classList.add('visible');
      } else {
        header.classList.remove('visible');
      }
    });

    // Apparaît aussi au hover sur le haut de page
    document.addEventListener('mousemove', (e) => {
      if (e.clientY < 80) {
        header.classList.add('visible');
      }
    });
  }


  // --- 3. SCROLL REVEAL (apparition au scroll) ---
  // Ajoute la classe .scroll-reveal aux sections à animer
  const revealElements = document.querySelectorAll(
    '.shopify-section h2, .shopify-section h3, .shopify-section p, .card-wrapper, .faq-item'
  );

  revealElements.forEach(el => el.classList.add('scroll-reveal'));

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target); // Stop observer après apparition
      }
    });
  }, { threshold: 0.15 });

  revealElements.forEach(el => revealObserver.observe(el));


  // --- 4. PARALLAXE sur le hero ---
  const heroBanner = document.querySelector('.banner__media img');
  if (heroBanner) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      heroBanner.style.transform = `scale(1.1) translateY(${scrolled * 0.3}px)`;
    });
  }


  // --- 5. HOVER CURSEUR : mise à jour dynamique pour cart drawer ---
  document.addEventListener('scroll', () => {
    const newTargets = document.querySelectorAll('a, button, .btn, .card-wrapper, summary');
    newTargets.forEach(el => {
      if (!el.dataset.cursorBound) {
        el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
        el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
        el.dataset.cursorBound = true;
      }
    });
  });

});